module.exports = __webpack_public_path__ + "img/pay-s-visa-amer.4606a4d.png";